import React from 'react';

import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import { styled } from '@mui/material/styles';
import { Grid, IconButton, Typography } from '@sunwisesoftware/sunwise-ui';
import is from 'is_js';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ContainerInfo = styled('div')`
    display: flex;
    flex-direction: row;
`;

const ContainerLabel = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    line-height: 12px;
`;

const getFileName = (document) => {
    let title = '';

    if (!is.undefined(document.title)) title = document.title;
    else if (!is.undefined(document.name)) title = document.name;

    return title;
};

const DocumentItem = ({ document, handleClickUpdate }) => {
    const { t } = useTranslation();
    return (
        <Grid container sx={{ width: '100%' }}>
            <Grid size="grow">
                <ContainerInfo>
                    <ContainerLabel>
                        <Typography fontWeight="bold" variant="body2">
                            {getFileName(document)}
                        </Typography>
                        <Typography variant="label">
                            <small>
                                {t('Loaded')} {document.created_at}
                            </small>
                        </Typography>
                    </ContainerLabel>
                </ContainerInfo>
            </Grid>

            <Grid>
                <IconButton
                    download={true}
                    href={document.file}
                    rel="noopener noreferrer"
                    target="_blank"
                    size="small"
                >
                    <DownloadIcon fontSize="inherit" />
                </IconButton>

                <IconButton onClick={handleClickUpdate} size="small">
                    <UploadIcon fontSize="inherit" />
                </IconButton>
            </Grid>
        </Grid>
    );
};

DocumentItem.propTypes = {
    document: PropTypes.object,
    handleClickUpdate: PropTypes.func,
};

export default DocumentItem;
